module.exports = __webpack_public_path__ + "static/media/sdg-video.c4e5e98a.mp4";